export default "__VITE_ASSET__5ba34e88__"